module.exports = __webpack_public_path__ + "static/media/community.46d3ee33.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/vectors/community.svg
// module id = 526
// module chunks = 0